import { useQuery } from "react-query";
import { getKycReport } from "services/user.service";

export default function useKycReport(userId: string) {
  return useQuery(["report", userId], async () => await getKycReport(userId), {
    enabled: userId ? true : false,
  });
}
